/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * GetDocument.Insider
 * OpenAPI spec version: 1.0.0
 */

export type ContactType = (typeof ContactType)[keyof typeof ContactType];

export const ContactType = {
    Builder: 1,
    BuildingManager: 2,
    BuildingSurveyor: 3,
    Developer: 4,
    Insurer: 5,
    SubContractor: 6,
    FacilitiesManager: 7,
    ProjectManager: 8,
} as const;
